import Icon from '@ant-design/icons';

import { ReactComponent as Live } from './svgs/live.svg';

const LiveIcon = props => {
  return <Icon component={Live} {...props} />;
};

export default LiveIcon;
